module.exports = __webpack_public_path__ + "static/img/SearchDetailPay1.ae94bec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailPay1.png
// module id = 769
// module chunks = 0